module.exports = __webpack_public_path__ + "static/media/icon-report-high-score-incomplete.7c7b012e.svg";